import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6 0.5C2.96243 0.5 0.5 2.96243 0.5 6C0.5 9.03757 2.96243 11.5 6 11.5C9.03757 11.5 11.5 9.03757 11.5 6C11.5 2.96243 9.03757 0.5 6 0.5ZM6.5 4C6.5 3.72386 6.27614 3.5 6 3.5C5.72386 3.5 5.5 3.72386 5.5 4V6C5.5 6.27614 5.72386 6.5 6 6.5C6.27614 6.5 6.5 6.27614 6.5 6V4ZM6 7.5C5.72386 7.5 5.5 7.72386 5.5 8C5.5 8.27614 5.72386 8.5 6 8.5H6.005C6.28114 8.5 6.505 8.27614 6.505 8C6.505 7.72386 6.28114 7.5 6.005 7.5H6Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.00008 0.666992C3.94999 0.666992 0.666748 3.95024 0.666748 8.00033C0.666748 12.0504 3.94999 15.3337 8.00008 15.3337C12.0502 15.3337 15.3334 12.0504 15.3334 8.00033C15.3334 3.95024 12.0502 0.666992 8.00008 0.666992ZM8.66675 5.33366C8.66675 4.96547 8.36827 4.66699 8.00008 4.66699C7.63189 4.66699 7.33342 4.96547 7.33342 5.33366V8.00033C7.33342 8.36852 7.63189 8.66699 8.00008 8.66699C8.36827 8.66699 8.66675 8.36852 8.66675 8.00033V5.33366ZM8.00008 10.0003C7.63189 10.0003 7.33342 10.2988 7.33342 10.667C7.33342 11.0352 7.63189 11.3337 8.00008 11.3337H8.00675C8.37494 11.3337 8.67342 11.0352 8.67342 10.667C8.67342 10.2988 8.37494 10.0003 8.00675 10.0003H8.00008Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M9.99992 0.833008C4.93731 0.833008 0.833252 4.93706 0.833252 9.99967C0.833252 15.0623 4.93731 19.1663 9.99992 19.1663C15.0625 19.1663 19.1666 15.0623 19.1666 9.99967C19.1666 4.93706 15.0625 0.833008 9.99992 0.833008ZM10.8333 6.66634C10.8333 6.2061 10.4602 5.83301 9.99992 5.83301C9.53968 5.83301 9.16659 6.2061 9.16659 6.66634V9.99967C9.16659 10.4599 9.53968 10.833 9.99992 10.833C10.4602 10.833 10.8333 10.4599 10.8333 9.99967V6.66634ZM9.99992 12.4997C9.53968 12.4997 9.16659 12.8728 9.16659 13.333C9.16659 13.7932 9.53968 14.1663 9.99992 14.1663H10.0083C10.4685 14.1663 10.8416 13.7932 10.8416 13.333C10.8416 12.8728 10.4685 12.4997 10.0083 12.4997H9.99992Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6165_14564)">
        <path d="M10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6ZM6.00488 7.5L6.05615 7.50244C6.30827 7.52805 6.50488 7.74112 6.50488 8C6.50488 8.25888 6.30827 8.47195 6.05615 8.49756L6.00488 8.5H6C5.72386 8.5 5.5 8.27614 5.5 8C5.5 7.72386 5.72386 7.5 6 7.5H6.00488ZM5.5 6V4C5.5 3.72386 5.72386 3.5 6 3.5C6.27614 3.5 6.5 3.72386 6.5 4V6C6.5 6.27614 6.27614 6.5 6 6.5C5.72386 6.5 5.5 6.27614 5.5 6ZM11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_6165_14564">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6165_14562)">
        <path d="M14.0001 8.00033C14.0001 4.68662 11.3138 2.00033 8.00008 2.00033C4.68637 2.00033 2.00008 4.68662 2.00008 8.00033C2.00008 11.314 4.68637 14.0003 8.00008 14.0003C11.3138 14.0003 14.0001 11.314 14.0001 8.00033ZM8.00659 10.0003L8.07495 10.0036C8.41111 10.0377 8.67326 10.3218 8.67326 10.667C8.67326 11.0122 8.41111 11.2963 8.07495 11.3304L8.00659 11.3337H8.00008C7.63189 11.3337 7.33342 11.0352 7.33342 10.667C7.33342 10.2988 7.63189 10.0003 8.00008 10.0003H8.00659ZM7.33342 8.00033V5.33366C7.33342 4.96547 7.63189 4.66699 8.00008 4.66699C8.36827 4.66699 8.66675 4.96547 8.66675 5.33366V8.00033C8.66675 8.36852 8.36827 8.66699 8.00008 8.66699C7.63189 8.66699 7.33342 8.36852 7.33342 8.00033ZM15.3334 8.00033C15.3334 12.0504 12.0502 15.3337 8.00008 15.3337C3.94999 15.3337 0.666748 12.0504 0.666748 8.00033C0.666748 3.95024 3.94999 0.666992 8.00008 0.666992C12.0502 0.666992 15.3334 3.95024 15.3334 8.00033Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_6165_14562">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6165_14560)">
        <path d="M17.4999 9.99967C17.4999 5.85754 14.1421 2.49967 9.99992 2.49967C5.85778 2.49967 2.49992 5.85754 2.49992 9.99967C2.49992 14.1418 5.85778 17.4997 9.99992 17.4997C14.1421 17.4997 17.4999 14.1418 17.4999 9.99967ZM10.0081 12.4997L10.0935 12.5037C10.5137 12.5464 10.8414 12.9015 10.8414 13.333C10.8414 13.7645 10.5137 14.1196 10.0935 14.1623L10.0081 14.1663H9.99992C9.53968 14.1663 9.16659 13.7932 9.16659 13.333C9.16659 12.8728 9.53968 12.4997 9.99992 12.4997H10.0081ZM9.16659 9.99967V6.66634C9.16659 6.2061 9.53968 5.83301 9.99992 5.83301C10.4602 5.83301 10.8333 6.2061 10.8333 6.66634V9.99967C10.8333 10.4599 10.4602 10.833 9.99992 10.833C9.53968 10.833 9.16659 10.4599 9.16659 9.99967ZM19.1666 9.99967C19.1666 15.0623 15.0625 19.1663 9.99992 19.1663C4.93731 19.1663 0.833252 15.0623 0.833252 9.99967C0.833252 4.93706 4.93731 0.833008 9.99992 0.833008C15.0625 0.833008 19.1666 4.93706 19.1666 9.99967Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_6165_14560">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconAlertCircle: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"alert-circle"} {...props} />
);
